module.exports = __webpack_public_path__ + "static/media/spreadsheetUpload.e026175b.svg";